import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import { countsReportesVisita } from 'api/reporteVisita';

const TIPOS = [
  { key: 'levantamiento', label: 'Levantamiento' },
  { key: 'diagnostico', label: 'Diagnóstico' },
  { key: 'preinspeccion', label: 'Preinspección' },
  { key: 'cierre', label: 'Cierre' },
  { key: 'libre', label: 'Libre' },
];

// Strip de conteos por tipo. Click en un tile filtra por ese tipo (toggle).
export default function ReporteVisitaKpiStrip({ active, onPick, reloadKey }) {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let cancelled = false;
    countsReportesVisita()
      .then((c) => !cancelled && setCounts(c || {}))
      .catch(() => !cancelled && setCounts({}));
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  return (
    <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
      {TIPOS.map((t) => (
        <Col key={t.key} xs={12} sm={8} md={Math.floor(24 / TIPOS.length) || 4} flex="1">
          <Card
            size="small"
            hoverable
            onClick={() => onPick(active === t.key ? undefined : t.key)}
            style={{
              borderColor: active === t.key ? '#1677ff' : undefined,
              cursor: 'pointer',
            }}
          >
            <Statistic title={t.label} value={counts[t.key] ?? 0} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}
